import { compose } from 'redux';
import { connect } from 'react-redux';
import RCTComprehensionQuestionView from './RCTComprehensionQuestionView';
import * as screen from '../../../../common/screen/screenActions';
import selectors from '../../../../rootSelectors';
import * as multiChoiceUtils from '../../../../common/questions/multiChoiceQuestionUtils';
import { COMPREHENSION } from '../../../../constants/assessmentItemType';
import { selectPossibleResponse, resetQuestionsAndTimeTrackingState } from '../../../../common/questions/questionsActions';
import {
    updateQuestionIndex, setIsReadyScriptPlayed,
    resetSelectedComprehensionResponses, fetchRctFluCompContent,
} from '../../../rctActions';
import {
    playReadyScript, onNextButtonClick, onBackButtonClick,
    restoreSelectedResponse, saveSelectedResponse,
} from './RCTComprehensionQuestionsActions';
import { narrateReset, stopAudio } from '../../../../common/audio/audioActions';
import { getQuestionIndex } from '../../../../common/utils/urlParsers';
import AvatarView from '../../../../common/avatar/avatarView';
import withAvatar from '../../../../common/avatar/withAvatar';
import RCT_AUDIO_INSTRUCTIONS from '../../../rctConstants';

const COMPREHENSION_AUDIO = RCT_AUDIO_INSTRUCTIONS.COMPREHENSION;

const mapStateToProps = (state, ownProps) => {
    const props = multiChoiceUtils.mapStateToProps(state);
    const activePassageIndex = getQuestionIndex(ownProps.match.params) - 1;
    return {
        ...props,
        isDataFetched: selectors.getIsRCTComprehensionDataFetched(state),
        isGreyedOut: selectors.getIsScreenGreyedOut(state),
        isTextPaneScroll: selectors.getIsTextPaneScrollEnabled(state),
        isNextButtonActive: selectors.getIsNextButtonActive(state),
        isBackButtonActive: selectors.getIsBackButtonActive(state),
        comprehensionItems: selectors.getRCTFluCompItems(state, COMPREHENSION, activePassageIndex),
        activePassageIndex,
        passageTitle: selectors.getPassageTitle(state, COMPREHENSION, activePassageIndex),
        segments: selectors.getSegments(state, COMPREHENSION, activePassageIndex),
        questionIndex: selectors.getQuestionIndex(state),
        totalQuestions: selectors.getComprehensionQuestionCount(state, activePassageIndex),
    };
};

const mapDispatchToProps = (dispatch) => {
    const props = multiChoiceUtils.mapDispatchToProps(dispatch);
    return {
        ...props,
        fetchContent: () => {
            dispatch(fetchRctFluCompContent());
        },
        readyScript: () => {
            dispatch(playReadyScript());
        },
        initializePassage: () => {
            dispatch(updateQuestionIndex(0));
            dispatch(resetSelectedComprehensionResponses());
            dispatch(screen.enableTextPaneScroll());
            dispatch(screen.unblockScreen());
        },
        selectAnswer: (questionIndex, responseIndex) => {
            dispatch(selectPossibleResponse(responseIndex));
            dispatch(saveSelectedResponse(questionIndex, responseIndex));
            dispatch(screen.activateNextButton());
        },
        onNext: (activePassageIndex) => {
            dispatch(screen.disableTextPaneScroll());
            dispatch(onNextButtonClick(activePassageIndex));
        },
        onBack: () => {
            dispatch(onBackButtonClick());
            dispatch(restoreSelectedResponse());
        },
        cleanup: () => {
            dispatch(setIsReadyScriptPlayed(false));
            dispatch(stopAudio());
            dispatch(narrateReset());
            dispatch(resetQuestionsAndTimeTrackingState());
            dispatch(screen.unmountScreen());
        },
    };
};

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.LOWER_LEFT,
    instructions: COMPREHENSION_AUDIO.avatarQuestion,
});

const RCTComprehensionQuestionsContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(RCTComprehensionQuestionView);

export default RCTComprehensionQuestionsContainer;
